/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styled from 'styled-components';
import {
  maxWidth,
  primaryColor, retina,
  secondaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { translateSkipAreas } from 'Utils/Constants';
import { useSelector } from 'react-redux';
import {
  selectArticleItemSummary, selectArticleItemSummaryLoaded,
  selectArticleItemSummaryLoading,
} from 'Selector/ArticleSector';
import ArticleShareButton from './ArticleShareButton';

type Props = {
  title: string,
  articleId: number,
  actionAddBtn?: () => void,
  articleImg: string,
  isFavorite?: boolean,
  hideAddToFavorite: boolean,
  articleLink: string;
  date: string;
  domain: string;
  shareAction?: () => void;
  alertId?: number
  url?: string
} | typeof defaultProps;

const defaultProps = {
  articleId: 0,
  title: '',
  actionAddBtn() { },
  articleImg: '',
  isFavorite: false,
  hideAddToFavorite: false,
  articleLink: '',
  date: '',
  domain: '',
  shareAction: () => { },
  alertId: 0,
  url: '',
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  .other-side {
    margin-left: 15px;
    .title {
      color: #000000;
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      line-height: 24px;
      font-size: 20px;
      letter-spacing: -0.42px;
      margin-bottom: 0px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 16px;
      }
    }
    .title:hover {
      cursor: pointer;
    }
    .add-btn {
      font-size: 9px;
      font-weight: ${wMedium};
      line-height: 15px;
      letter-spacing: -0.23px;
      color: #fff;
      border-radius: 12px;
      background-color: ${primaryColor};
      padding: 0px 8px;
      margin-top: 0px;
      cursor: pointer;
      display: inline-block;
      margin-left: 0px;
    }
    .favorite {
      display: none;
    }
    .sub-heading {
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      line-height: 14px;
      font-size: 14px;
      letter-spacing: -0.42px;
      margin-bottom: 0px;
    }
    .link {
      color: ${primaryColor};
      &:hover {
        cursor: pointer;
      }
    }

    .share-article {
      cursor: pointer;
      display: inline-block;
      margin-left: 0px;
      vertical-align: middle;
    }
    
  }
  .company-img{
    height: 60px;
    width: 60px;
    min-width: 60px;
    object-fit: cover;
  }
`;

const ContentArticleTile = function ContentArticleTile(props: Props) {
  const {
    title, actionAddBtn, articleImg, isFavorite, hideAddToFavorite, articleLink,
    date, domain, articleId, alertId, url,
  } = props;
  const onClickHandler = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (articleLink) { window.open(articleLink); }
  };
  const articleSummaryData = useSelector(selectArticleItemSummary);
  const summaryLoadingFlag = useSelector(selectArticleItemSummaryLoading);
  const summaryLoadedFlag = useSelector(selectArticleItemSummaryLoaded);
  return (
    <Wrapper>
      {/* alt empty because of reason */}
      <img src={articleImg || ''} onClick={onClickHandler} alt="" className="company-img" />
      <span className="other-side">
        <h6 className="title text-truncate-one-line" onClick={onClickHandler}>{title}</h6>
        <span className="sub-heading">
          {`${date} `}
          {domain
            && '|  '}
        </span>
        <span className={`sub-heading link ${translateSkipAreas}`} onClick={onClickHandler}>
          {domain}
        </span>

        {(!hideAddToFavorite && !isFavorite)
          && (
            <span className="sub-heading">
              {' | '}
            </span>
          )}
        {hideAddToFavorite ? null
          : (
            <span
              className={`add-btn ${isFavorite ? 'favorite' : ''}`}
              onClick={actionAddBtn}
              tabIndex={0}
              onKeyPress={actionAddBtn}
              role="button"
              aria-label="Add to Favorite"
            >
              Add to Favorite
            </span>
          )}

        {(!hideAddToFavorite || isFavorite)
          && (
            <span className="sub-heading">
              {' | '}
            </span>
          )}
        <span className="sub-heading share-article">
          <ArticleShareButton
            articleId={articleId}
            title={title}
            img={articleImg}
            domain={domain}
            alertId={alertId}
            url={url}
            articleSummary={articleSummaryData}
            summaryLoaded={summaryLoadedFlag}
            summaryLoading={summaryLoadingFlag}
          />
        </span>
      </span>
    </Wrapper>
  );
};

ContentArticleTile.defaultProps = defaultProps;
export default ContentArticleTile;
